<template>
    <article class="post">
        <router-link :to="{ name: 'view-post', params: { group: post.group.slug, post: post.slug }}" class="featured-image" :style="'background-image: url(' + post.featured_image + '); background-position: 52% 51% !important;'" v-if="post.featured_image"></router-link>

        <div class="post-content">
            <div class="title">
                <router-link :to="{ name: 'view-post', params: { group: post.group.slug, post: post.slug }}">
                    <h1>{{ post.title }}</h1>
                </router-link>

                <router-link :to="{ name: 'view-post', params: { group: post.group.slug, post: post.slug }}">
                    <p>{{ post.excerpt }}</p>
                </router-link>

                <div class="byline">
                    <avatars :users="post.authors" v-if="post.authors"></avatars>
                    <div>
                        {{ post.created_at }}
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        props: ['post', 'type'],
        created() {
            //console.log(this.position);
            //$('[data-toggle="tooltip"]').tooltip();
        }
    }
</script>